import script from "./OrderLinkStatsView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderLinkStatsView.vue?vue&type=script&setup=true&lang=js"

import "./OrderLinkStatsView.vue?vue&type=style&index=0&id=796530c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796530c4"]])

export default __exports__